// Backend API client for device + checkout endpoints.
// device_id is a UUID stored in localStorage; it identifies this device for paywall purposes.

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEVICE_KEY = "rs_device_id";

export function getDeviceId() {
  if (typeof localStorage === "undefined") return "";
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id =
      (typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`);
    try {
      localStorage.setItem(DEVICE_KEY, id);
    } catch {
      // ignore
    }
  }
  return id;
}

async function jsonFetch(url, opts = {}) {
  const res = await fetch(url, {
    headers: { "Content-Type": "application/json", ...(opts.headers || {}) },
    ...opts,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`API ${res.status}: ${text || res.statusText}`);
  }
  return res.json();
}

export async function initDevice() {
  const device_id = getDeviceId();
  return jsonFetch(`${API_BASE}/device/init`, {
    method: "POST",
    body: JSON.stringify({ device_id }),
  });
}

export async function reportPhoto() {
  const device_id = getDeviceId();
  return jsonFetch(`${API_BASE}/device/photo`, {
    method: "POST",
    body: JSON.stringify({ device_id }),
  });
}

export async function getDeviceState() {
  const device_id = getDeviceId();
  return jsonFetch(`${API_BASE}/device/${encodeURIComponent(device_id)}`);
}

export async function createCheckout() {
  const device_id = getDeviceId();
  const origin_url = window.location.origin;
  return jsonFetch(`${API_BASE}/checkout/create`, {
    method: "POST",
    body: JSON.stringify({ device_id, origin_url }),
  });
}

export async function getCheckoutStatus(sessionId) {
  return jsonFetch(
    `${API_BASE}/checkout/status/${encodeURIComponent(sessionId)}`
  );
}

// Restore Premium on this device by looking up the buyer email.
// Returns { is_premium, restored, message }.
export async function restorePremiumByEmail(email) {
  const device_id = getDeviceId();
  return jsonFetch(`${API_BASE}/premium/restore`, {
    method: "POST",
    body: JSON.stringify({ device_id, email }),
  });
}
